// extracted by mini-css-extract-plugin
module.exports = {"containerCarts":"ShoppingCarts_containerCarts__2gR9u"};